import { Paragraph } from '@zillow/constellation-10';

const WizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        We&apos;ll assign your listing a random number that will automatically route incoming calls to your phone.
        It&apos;s up to you to share your number directly with an applicant.
      </Paragraph>
    </div>
  );
};

export default WizardTipContent;
